import React from 'react'
import Image from 'next/image'
import Link from 'next/link';

const SidebarCard = ({ title, imageSrc, altText, link }) => (
  <div className="w-full  bg-[#FBFBFB] hover:bg-[#92b5db36] p-4 rounded dark:bg-gray-800 overflow-hidden mx-auto">
    <div className="relative flex">
        <Link href={link}>
          <p className="w-40 my-0 text-sm 2xl:w-56 line-clamp-3 xl:line-clamp-4">{title}</p>
        </Link>
        <Link href={link}>
          <Image
            priority={true}
            className="hidden h-full w-14 xl:ml-2 xl:block"
            src={imageSrc}
            width={2000}
            height={2000}
            alt={altText}
          />
        </Link>
        {process.env.IS_SALE == 'active'  && (
          <div className='absolute right-0 px-2 py-3 text-xs font-semibold text-white bg-red-600 rounded-full -top-4'> SALE </div>
        )}
    </div>
  </div>
);

export default SidebarCard;
